import { env as runtimeEnv } from 'next-runtime-env';

const env = (key: string) => runtimeEnv(key) as string;

export const SETTINGS = {
  public: {
    tmsToken: env('NEXT_PUBLIC_TMS_TOKEN'),
    urlOrderSvc: env('NEXT_PUBLIC_URL_ORDER_SVC'),
    urlOrderWeb: env('NEXT_PUBLIC_URL_ORDER_WEB'),
    urlContractWeb: env('NEXT_PUBLIC_URL_CONTRACT_WEB'),
    urlPlanSvc: env('NEXT_PUBLIC_URL_PLAN_SVC'),
    urlHubWeb: env('NEXT_PUBLIC_URL_HUB_WEB'),
    urlSaleWeb: env('NEXT_PUBLIC_URL_SALE_WEB'),
    urlAuthWeb: env('NEXT_PUBLIC_URL_AUTH_WEB'),
    urlAssetSvc: env('NEXT_PUBLIC_URL_ASSET_SVC'),
    urlNotificationSvc: env('URL_NOTIFICATION_SVC'),
    basePath: env('NEXT_PUBLIC_BASE_PATH'),
    urlSystemEventSvc: env('NEXT_PUBLIC_URL_SYSTEM_EVENT_SVC'),
    alphaCollaborators: env('NEXT_PUBLIC_ALPHA_COLLABORATORS'),
  },
  server: {
    basePath: env('BASE_PATH'),
    urlPlanSvc: env('URL_PLAN_SVC'),
  },
};
